export let XIDItemType = /*#__PURE__*/function (XIDItemType) {
  XIDItemType["XC"] = "xc";
  XIDItemType["UID"] = "uid";
  return XIDItemType;
}({});
export let XIDState = /*#__PURE__*/function (XIDState) {
  XIDState["NEW"] = "NEW";
  XIDState["CHANGED"] = "CHANGED";
  XIDState["EXISTING"] = "EXISTING";
  XIDState["TIMEOUT"] = "TIMEOUT";
  XIDState["ERROR"] = "ERROR";
  XIDState["UNAVAILABLE"] = "UNAVAILABLE";
  XIDState["MALFORMED"] = "MALFORMED";
  XIDState["UNKNOWN"] = "UNKNOWN";
  return XIDState;
}({});